import { capitalizeFirstLetter } from 'commons/utils/string.utils';
import { DeviceTypeDetails } from 'modules/devices/domain/api/device-type.api';
import { SettingsSideBarItemMenu } from 'modules/settings/components/side-menu-list';
import { settingsModulePaths } from 'core/routes/routes';

export const mapDeviceTypeToSettingsMenuOption = (deviceType: DeviceTypeDetails): SettingsSideBarItemMenu => ({
    title: capitalizeFirstLetter(deviceType.name),
    url: settingsModulePaths.deviceConfiguration.replace(':id', deviceType.slug),
});
